import React from 'react'
import Header from './Header'
import Content from './Content'
import Footer from './footer'

function landing() {
    return (
        <div>
            <Header></Header>
          <Content></Content>
          <Footer></Footer>
        </div>
    )
}

export default landing
